export default function AddressFormFields({ form, setForm, addressTypes }) {
  return (
    <div className="row g-2 mt-3">

      <div className="col-12">
        <input
          className="form-control"
          placeholder="Address Title"
          value={form.AddressTitle}
          onChange={(e) => setForm({ ...form, AddressTitle: e.target.value })}
          required
        />
      </div>

      <div className="col-md-6">
        <input
          className="form-control"
          placeholder="Flat / House Number"
          value={form.FaltHousNumber}
          onChange={(e) =>
            setForm({ ...form, FaltHousNumber: e.target.value })
          }
        />
      </div>

      <div className="col-md-6">
        <input
          className="form-control"
          placeholder="Pincode"
          value={form.Pincode}
          onChange={(e) => setForm({ ...form, Pincode: e.target.value })}
          required
        />
      </div>

      <div className="col-md-6">
        <input
          className="form-control"
          placeholder="Street"
          value={form.Street}
          onChange={(e) => setForm({ ...form, Street: e.target.value })}
          required
        />
      </div>

      <div className="col-md-6">
        <input
          className="form-control"
          placeholder="Locality"
          value={form.Locality}
          onChange={(e) => setForm({ ...form, Locality: e.target.value })}
          required
        />
      </div>

      <div className="col-12">
        <select
          className="form-select"
          value={form.AddressTypeID}
          onChange={(e) =>
            setForm({ ...form, AddressTypeID: e.target.value })
          }
        >
          {addressTypes.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
